import { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup, Button } from 'reactstrap';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import {
    getLegacyMarcas,
    getLegacyModelos,
    getLegacyColores,
    getLegacyTiposCombustible,
    getLegacyTiposTraccion,
    getLegacyTiposTransmision,
    getLegacyPersonas
} from '../../slices/thunks';
import useUpdateVehiculo from '../Hooks/useUpdateVehiculo';
import useObtenerVehiculoPorPatente from '../Hooks/useObtenerVehiculoPorPatente';
import ModalModificarPersona from './ModalModificarPersona';


const ModalModificarVehiculo = ({ isOpen, toggle, onSave, selectedVehiculo }) => {
    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const departamento = useSelector((state) => state.Context.departamento)
    const userInfo = useSelector((state) => state.UserInfo.userInfo)
    const [formData, setFormData] = useState({
        patente: '',
        marca: {},
        modelo: {},
        vin: '',
        chasis: '',
        color: {},
        tipoCombustible: {},
        tipoTraccion: {},
        tipoTransmision: {},
        ano: '',
        motor: '',
        rut: ''
    });
    const [modeloPendiente, setModeloPendiente] = useState(null)

    const marcas = useSelector((state) => state.LegacyMarcas.legacyMarcas)
    const modelos = useSelector((state) => state.LegacyModelos.legacyModelos)
    const colores = useSelector((state) => state.LegacyColores.legacyColores)
    const tiposCombustible = useSelector((state) => state.LegacyTiposCombustible.legacyTiposCombustible)
    const tiposTraccion = useSelector((state) => state.LegacyTiposTraccion.legacyTiposTraccion)
    const tiposTransmision = useSelector((state) => state.LegacyTiposTransmision.legacyTiposTransmision)
    const personas = useSelector((state) => state.LegacyPersonas.legacyPersonas)
    const dispatch = useDispatch()

    const { vehiculo, loading: loadingVehiculo } = useObtenerVehiculoPorPatente(isOpen ? selectedVehiculo : null);
    const { updateVehiculo, loading: updating } = useUpdateVehiculo();


    const handleSelectCombustible = (opcion) => {
        setFormData(prev => ({ ...prev, tipoCombustible: opcion }));
    };

    const handleSelectTraccion = (opcion) => {
        setFormData(prev => ({ ...prev, tipoTraccion: opcion }));
    };

    const handleSelectTransmision = (opcion) => {
        setFormData(prev => ({ ...prev, tipoTransmision: opcion }));
    };


    useEffect(() => {
        if (vehiculo && Object.keys(vehiculo).length > 0) {
            setFormData(prev => ({
                ...prev,
                patente: vehiculo.PATENT?.trim() || '',
                marca: { value: vehiculo.MARCAS, label: buscarNombreMarca(vehiculo.MARCAS) },
                vin: vehiculo.NROVIN || '',
                chasis: vehiculo.NCHASI || '',
                color: { label: buscarColor(vehiculo.CCOLOR), value: vehiculo.CCOLOR },
                tipoCombustible: { label: buscarTipoCombustible(vehiculo.COMBUS), value: vehiculo.COMBUS },
                tipoTraccion: { label: buscarTipoTraccion(vehiculo.TRACCI), value: vehiculo.TRACCI },
                tipoTransmision: { label: buscarTipoTransmision(vehiculo.TRASMI), value: vehiculo.TRASMI },
                ano: vehiculo.ANOFAB || '',
                motor: vehiculo.NMOTOR || '',
                rut: vehiculo.CLIENT || ''
            }));
            setModeloPendiente(vehiculo.MODELO);
        }
    }, [vehiculo])

    useEffect(() => {
        dispatch(getLegacyMarcas({ tenantId, empresa }))
        dispatch(getLegacyColores({ tenantId, empresa }))
        dispatch(getLegacyTiposCombustible({ tenantId, empresa }))
        dispatch(getLegacyTiposTraccion({ tenantId, empresa }))
        dispatch(getLegacyTiposTransmision({ tenantId, empresa }))
        dispatch(getLegacyPersonas({ tenantId, empresa }))
    }, [tenantId, empresa])

    useEffect(() => {
        if (formData.marca?.value)
            dispatch(getLegacyModelos({ tenantId, empresa, marca: formData.marca?.value }))
    }, [formData.marca])


    useEffect(() => {
        if (Array.isArray(modelos) && modelos?.length > 0) {
            if (modeloPendiente) {
                let m = { value: modeloPendiente, label: buscarNombreModelo(modeloPendiente) }
                setModeloPendiente(null)
                setFormData(prev => ({ ...prev, modelo: m }));
            }
        }
    }, [modelos])

    function parseMarca(marca) {
        return { value: marca?.MARCAS, label: marca?.DESCRI };
    }

    function parseModelo(modelo) {
        return { value: modelo?.MODELO, label: modelo?.DESCRI };
    }

    function parseColor(color) {
        return { value: color?.codreg, label: color?.descri };
    }

    function parseTiposTraccion(tipoTraccion) {
        return { value: tipoTraccion?.codreg, label: tipoTraccion?.descri };
    }

    function parseTiposTransmision(tipoTransmision) {
        return { value: tipoTransmision?.codreg, label: tipoTransmision?.descri };
    }

    function parseTiposCombustible(tipoCombustible) {
        return { value: tipoCombustible?.codreg, label: tipoCombustible?.descri };
    }

    function buscarNombreMarca(codigo) {
        if (Array.isArray(marcas) && marcas.length > 0)
            return marcas?.find(m => m.MARCAS == codigo)?.DESCRI
    }

    function buscarNombreModelo(codigo) {
        if (Array.isArray(modelos) && modelos.length > 0)
            return modelos?.find(m => m.MODELO == codigo)?.DESCRI
    }

    function buscarColor(codigo) {
        if (Array.isArray(colores) && colores.length > 0)
            return colores?.find(m => m.codreg == codigo)?.descri
    }

    function buscarTipoCombustible(codigo) {
        if (Array.isArray(tiposCombustible) && tiposCombustible.length > 0)
            return tiposCombustible?.find(m => m.codreg == codigo)?.descri
    }

    function buscarTipoTraccion(codigo) {
        if (Array.isArray(tiposTraccion) && tiposTraccion.length > 0)
            return tiposTraccion?.find(m => m.codreg == codigo)?.descri
    }

    function buscarTipoTransmision(codigo) {
        if (Array.isArray(tiposTransmision) && tiposTransmision.length > 0)
            return tiposTransmision?.find(m => m.codreg == codigo)?.descri
    }


    const handleInputChange = (e) => {

        if (e?.target) {
            const { name, value } = e.target;
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleMarcaChange = (e) => {
        if (e) {
            if (!e.label) {
                e.label = buscarNombreMarca(e.value)
            }
            setFormData(prev => ({ ...prev, marca: e }));
        }
    };

    const handleColorChange = (e) => {
        if (e) {
            if (!e.label) {
                e.label = buscarColor(e.value)
            }
            setFormData(prev => ({ ...prev, color: e }));
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await updateVehiculo(selectedVehiculo, formData);
        if (result.success) {
            onSave();
            handleCancel();
        } else {
            alert('Error al actualizar vehículo: ' + result.error);
        }
    };

    const handleCancel = () => {
        // Reset formData if needed
        toggle();
    };

    // ******************Modal Modificar Persona
    const [modalModificarPersona, setModalModificarPersona] = useState(false)
    const toggleModalPersona = () => {
        toggleModalPersona(!modalModificarPersona);
    };

    const handleModalModificarPersona = () => {
        setModalModificarPersona(true);
    }

    const handleGuardarPersona = (datosPersona) => {
        // Ejemplo de guardado
        const nuevaRecepcion = {
            id: Date.now(),
            ...datosPersona,
            fechaCreacion: new Date().toISOString()
        };


        // Mostrar mensaje de éxito (opcional)
        //alert('Persona creado exitosamente');

        //  llamar al hook para guardar persona
        // await api.guardarPersona(datosPersona);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                <i className="ri-car-line me-2"></i>
                Vehículo
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalModificarPersona
                    isOpen={modalModificarPersona}
                    toggle={toggleModalPersona}
                    onSave={handleGuardarPersona}
                    persona={Array.isArray(personas) && personas.length > 0 ? personas[0] : {}}
                />
                <ModalBody>
                    <div>
                        {loadingVehiculo ? (
                            <div className="text-center">Cargando datos del vehículo...</div>
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="patente">Patente</Label>
                                            <Input
                                                type="text"
                                                id="patente"
                                                name="patente"
                                                value={vehiculo && typeof vehiculo.PATENT == 'string' ? vehiculo.PATENT.trim() : ''}
                                                readOnly
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="rut">Rut Propietario</Label>
                                            <Input
                                                type="text"
                                                id="rut"
                                                name="rut"
                                                value={formData.rut}
                                                onChange={handleInputChange}
                                                placeholder="Ej: 78.123.456-7"
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center my-4">
                                    <div className="flex-grow-1 border-top"></div>
                                    <span className="mx-3 text-muted">Información del Vehículo</span>
                                    <div className="flex-grow-1 border-top"></div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="marca">Marca</Label>
                                            <Select
                                                id="marca"
                                                placeholder="Marcas..."
                                                value={formData.marca}
                                                onChange={(opcion) => { handleMarcaChange(opcion) }}
                                                options={Array.isArray(marcas) && marcas.length > 0 ? marcas?.map(parseMarca) : []}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="modelo">Modelo</Label>
                                            <Select
                                                id="modelo"
                                                placeholder="Modelos..."
                                                value={formData.modelo}
                                                onChange={(opcion) => setFormData(prev => ({ ...prev, modelo: opcion }))}
                                                options={Array.isArray(modelos) && modelos.length > 0 ? modelos?.map(parseModelo) : []}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="vin">VIN</Label>
                                            <Input
                                                type="text"
                                                id="vin"
                                                name="vin"
                                                value={formData.vin}
                                                onChange={handleInputChange}
                                                placeholder="Ej: 1FM4K7B52FEB67263"
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="chasis">Chasis</Label>
                                            <Input
                                                type="text"
                                                id="chasis"
                                                name="chasis"
                                                value={formData.chasis}
                                                onChange={handleInputChange}
                                                placeholder="Ej: 4P3DTFA3WDE902777"
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="ano">Año</Label>
                                            <Input
                                                type="text"
                                                id="ano"
                                                name="ano"
                                                value={formData.ano}
                                                onChange={handleInputChange}
                                                placeholder="Ej: 2020"
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="motor">Motor</Label>
                                            <Input
                                                type="text"
                                                id="motor"
                                                name="motor"
                                                value={formData.motor}
                                                onChange={handleInputChange}
                                                placeholder="Ej: 67195000539462"
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="color">Color</Label>
                                            <Select
                                                id="color"
                                                placeholder="Colores..."
                                                value={formData.color}
                                                onChange={(opcion) => { handleColorChange(opcion) }}
                                                options={Array.isArray(colores) && colores.length > 0 ? colores?.map(parseColor) : []}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="transmision">Transmisión</Label>
                                            <Select
                                                id="transmision"
                                                placeholder="Seleccione..."
                                                value={formData.tipoTransmision}
                                                onChange={(opcion) => { handleSelectTransmision(opcion); }}
                                                options={Array.isArray(tiposTransmision) && tiposTransmision.length > 0 ? tiposTransmision?.map(parseTiposTransmision) : []}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="combustible">Combustible</Label>
                                            <Select
                                                id="combustible"
                                                placeholder="Seleccione..."
                                                value={formData.tipoCombustible}
                                                onChange={(opcion) => { handleSelectCombustible(opcion); }}
                                                options={Array.isArray(tiposCombustible) && tiposCombustible.length > 0 ? tiposCombustible?.map(parseTiposCombustible) : []}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="traccion">Tracción</Label>
                                            <Select
                                                id="traccion"
                                                placeholder="Seleccione..."
                                                value={formData.tipoTraccion}
                                                onChange={(opcion) => { handleSelectTraccion(opcion); }}
                                                options={Array.isArray(tiposTraccion) && tiposTraccion.length > 0 ? tiposTraccion?.map(parseTiposTraccion) : []}
                                                onFocus={(e) => {
                                                    e.target.readOnly = true;
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>


                            </>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-light" onClick={handleCancel}>
                        Cancelar
                    </button>
                    <Button type="submit" color="success" disabled={updating}>
                        <i className="ri-save-line me-1"></i>
                        Actualizar
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default ModalModificarVehiculo;